import '../node_modules/bootstrap/dist/css/bootstrap.min.css';

import NotificationPopup from './ui/atoms/popup/popup';
import AuthContext from './context/auth/state';
import { RoleContext } from './context/role/state';
import { DeviceContext } from './context/device/state';
import { CarritoProvider } from './context/carrito/context';

import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';

import { SidebarProvider } from './context/sidebar/SidebarContext';
import { ThemeProvider } from './context/theme/ThemeContext';
import AppThemeProvider from './ui/providers/AppThemeProvider';
import { useEffect } from 'react';
import packageJson from '../package.json';
import { versionService } from './services/versionService';
function App() {
  useEffect(() => {
    const checkAppVersion = async () => {
      const currentVersion = packageJson.version;
      const response = await versionService.checkVersion(currentVersion);
      if (response && response.success && response.data && response.data.update_required) {
        sessionStorage.setItem('update_required', 'true');
        window.dispatchEvent(new CustomEvent('app-update-available'));
      }
    };

    checkAppVersion();
  }, []);

  return (
    <ThemeProvider>
      <AppThemeProvider>
        <AuthContext>
          <SidebarProvider>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DeviceContext>
              <CarritoProvider>
                <NotificationPopup />
                <RoleContext />
              </CarritoProvider>
            </DeviceContext>
          </LocalizationProvider>
          </SidebarProvider>
        </AuthContext>
      </AppThemeProvider>
    </ThemeProvider>
  );
}

export default App;
